// src/store/api/cartApi.js
import { productApi } from './productApi';
import { setUser } from '../slice/userSlice';
const extendedUserApi = productApi.injectEndpoints({
  endpoints: (builder) => ({
    userProfile: builder.query({
      query: () => '/user',
      providesTags: ['User'],
    }),
    loginUser: builder.mutation({
      query: ({ mobile, password }) => ({
        url: '/login',
        method: 'POST',
        body: { mobile, password },
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // Optionally store user data in Redux if needed
          dispatch(setUser(data.user));
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
      invalidatesTags: ['User'],
    }),
    signUpUser: builder.mutation({
      query: ({name, email, password}) => ({
        url: `/signup`,
        method: 'POST',
        body: { name, email, password },
      }),
      invalidatesTags: ['User'],
    }),
    userProfileUpdate: builder.mutation({
      query: (formData) => ({
        url: `/user/profile`,
        method: 'PATCH',
        body: formData
      }),
      invalidatesTags: ['User'],
    }),
    getAllSupplier: builder.query({
      query: () => '/users/suppliers',
      transformResponse: (response) => response.data,
      providesTags: ['supplier'],
    }),
    getSupplierById: builder.query({
      query: (id) => `/users/supplier/${id}`,
      providesTags: (result, error, id) => [{ type: 'Supplier', id }],
    }),
    addSupplier: builder.mutation({
      query: (supplierData) => ({
        url: '/users/add-supplier',
        method: 'POST',
        body: supplierData
      }),
      invalidatesTags: ['Supplier'],
    }),
    updateSupplier: builder.mutation({
      query: ({ id, ...values }) => ({
        url: `/users/supplier/${id}`,
        method: 'PATCH',
        body: values
      }),
      invalidatesTags: ['Supplier'],
    }),
    deleteSupplier: builder.mutation({
      query: (id) => ({
        url: `/users/supplier/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Supplier'],
    }),

    addCustomer: builder.mutation({
      query: (customerData) => ({
        url: '/users/add-customer',
        method: 'POST',
        body: customerData
      }),
      invalidatesTags: ['Customer'],
    }),
    getAllCustomer: builder.query({
      query: () => '/users/customers',
      transformResponse: (response) => response.data,
      providesTags: ['Customer'],
    }),
    getCustomerById: builder.query({
      query: (id) => `/users/customer/${id}`,
      providesTags: (result, error, id) => [{ type: 'Customer', id }],
    }),
    updateCustomer: builder.mutation({
      query: ({ id, ...customerData }) => ({
        url: `/users/customer/${id}`,
        method: 'PATCH',
        body: customerData
      }),
      invalidatesTags: ['Customer'],
    }),
    deleteCustomer: builder.mutation({
      query: (id) => ({
        url: `/users/customer/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customer'],
    }),
    addUser: builder.mutation({
      query: (userData) => ({
        url: '/users/add-user',
        method: 'POST',
        body: userData
      }),
      invalidatesTags: ['User'],
    }),
    getAllUsers: builder.query({
      query: () => 'users/users',
      transformResponse: (response) => response.data,
      providesTags: ['User'],
    }),
    getUserById: builder.query({
      query: (id) => `/users/user/${id}`,
      providesTags: (result, error, id) => [{ type: 'User', id }],
    }),
    updateUser: builder.mutation({
      query: ({ id, ...userData }) => ({
        url: `/users/user/${id}`,
        method: 'PATCH',
        body: userData
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'User', id }],
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `users/user/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLoginUserMutation,
  useSignUpUserMutation,
  useGetAllSupplierQuery,
  useAddSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
  useGetSupplierByIdQuery,
  useGetAllCustomerQuery,
  useGetCustomerByIdQuery,

  useUserProfileUpdateMutation,
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,

  useAddUserMutation,
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = extendedUserApi;
